<template>
  <div class="myIndex">
    <!-- <topTitle title="我的"></topTitle> -->
    <div class="myTop">
      <div class="bt">我的</div>
      <div class="zl">
        <div class="img" @click="jump(0)">
          <!-- <img :src="personal.face" alt /> -->
          <van-image width="100%" height="100%" :src="personal.face"  fit="cover" round/>
        </div>
        <div>
          <p>账号：{{personal.uname}}</p>
          <p class="mycode" @click="copy(personal.invitation_code)">邀请码：{{personal.invitation_code}}</p>
        </div>
        
      </div>
      <div class="number">
        <div @click="jump(1)">
          <h3>{{personal.member_statistics_dto.goods_collect_count}}</h3>
          <p>收藏商品</p>
        </div>
        <div @click="jump(2)">
          <h3>{{personal.member_statistics_dto.shop_collect_count}}</h3>
          <p>收藏店铺</p>
        </div>
        <div @click="jump(3)">
          <h3>{{personal.member_statistics_dto.history_count}}</h3>
          <p>浏览足迹</p>
        </div>
      </div>
    </div>
    <div class="order">
      <div class="top" >
        <h2>我的订单</h2>
        <div @click="jump(20)">
          全部订单
          <div>
            <img src="../../assets/localImage/path.png" alt />
          </div>
        </div>
      </div>
      <div class="body">
        <div class="fk"  @click="jump(4)">
          <div>
            <img src="../../assets/localImage/pendingpayment.png" alt />
          </div>
          <p>待付款</p>
        </div>
        <div class="fh"  @click="jump(5)">
          <div>
            <img src="../../assets/localImage/tobeshipped.png" alt />
          </div>
          <p>待发货</p>
        </div>
        <div class="sh"  @click="jump(6)">
          <div>
            <img src="../../assets/localImage/goodstobereceived.png" alt />
          </div>
          <p>待收货</p>
        </div>
        <div class="pj"  @click="jump(7)">
          <div>
            <img src="../../assets/localImage/tobeevaluated.png" alt />
          </div>
          <p>待评价</p>
        </div>
        <div class="hh"  @click="jump(8)">
          <div>
            <img src="../../assets/localImage/jq.png" alt />
          </div>
          <p>退换货</p>
        </div>
      </div>
    </div>
    <div class="account">
      <div class="top">
        <h2>我的账户</h2>
      </div>
      <div class="body">
        <div  @click="jump(9)">
          <div>
            <img src="../../assets/localImage/heavycurrency.png" alt />
          </div>
          <p>重消币</p>
        </div>
        <div  @click="jump(10)">
          <div>
            <img src="../../assets/localImage/zb.png" alt />
          </div>
          <p>消费记录</p>
        </div>
        <div  @click="jump(11)">
          <div>
            <img src="../../assets/localImage/changepassword.png" alt />
          </div>
          <p>地址管理</p>
        </div>
        <div  @click="jump(12)">
          <div>
            <img src="../../assets/localImage/code.png" alt />
          </div>
          <p>我的二维码</p>
        </div>
        <div  @click="jump(13)">
          <div>
            <img src="../../assets/localImage/dealer.png" alt />
          </div>
          <p>我的佣金</p>
        </div>
      </div>
    </div>
    <div class="operation">
      <div @click="jump(14)">
        <div class="img">
          <img src="../../assets/localImage/tiezi.png" alt />
        </div>
        <div class="nr" >
          <p>我的帖子</p>
        </div>
      </div>
      <div @click="jump(15)">
        <div class="img">
          <img src="../../assets/localImage/momentmessage.png" alt />
        </div>
        <div class="nr">
          <p>我的评论</p>
        </div>
      </div>
      <div @click="jump(16)">
        <div class="img">
          <img src="../../assets/localImage/clearcache.png" alt />
        </div>
        <div class="nr">
          <p>清除缓存</p>
        </div>
      </div>
      <!-- <div @click="jump(17)">
        <div class="img">
          <img src="../../assets/localImage/wenti.png" alt />
        </div>
        <div class="nr">
          <p>常见问题</p>
        </div>
      </div> -->
      <div @click="jump(18)">
        <div class="img">
          <img src="../../assets/localImage/fapiao.png" alt />
        </div>
        <div class="nr">
          <p>增票资质</p>
        </div>
      </div>
      <div @click="jump(19)">
        <div class="img">
          <img src="../../assets/localImage/customerservice.png" alt />
        </div>
        <div class="nr nobor">
          <p>客服电话</p>
        </div>
      </div>
    </div>
    <div class="logout">
      <div @click="show=true">退出</div>
    </div>
    <fontNav></fontNav>

    <van-dialog v-model="show" show-cancel-button class="pop" @confirm='signOut()'>
      <h3>提示</h3>
      <p>确定要退出吗？</p>
    </van-dialog>

    <van-dialog v-model="showkf" show-cancel-button class="pop" @confirm='ddh()'>
      <h3>请拨打客服电换</h3>
      <p>{{kfmobile}}</p>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog,Toast } from 'vant';
import fontNav from "../../components/fontNav.vue";
export default {
  name: "myIndex",
  data() {
    return {
      show: false,
      showkf:false,
      loginInfo:{},
      kfmobile:"",
      personal:{
        member_statistics_dto:{
          goods_collect_count:0,
          shop_collect_count:0,
          history_count:0,
        }
      }
    };
  },
  components: {
    fontNav
  },
  created(){
    this.loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
    this.infoData();
    this.kfdh()
  },
  mounted(){
  },
  methods: {
     copy(text) {
      var input = document.createElement('input');
      input.setAttribute('readonly', 'readonly'); // 防止手机上弹出软键盘
      input.setAttribute('value', text);
      document.body.appendChild(input);
      // input.setSelectionRange(0, 9999);
      input.select();
      var res = document.execCommand('copy');
      document.body.removeChild(input);
      Toast('邀请码复制成功');
      return res;
    },
    kfdh(){
      this.getRequest( `goods/servicePhone`).then(res => {
       this.kfmobile = res.data.data
      })
    },
    infoData(){
      this.getRequest( `members`).then(res => {
        if(res.data.code != 1){
          this.personal = res.data.data;
          localStorage.setItem('mobile',this.personal.mobile)
        }
      })
    },
    jump(type) {
      switch (type) {
        case 0:
          this.$router.push({path:'personalData'});
          break;
        case 1:
          this.$router.push({path:'collectionGoods',query:{type:0}});
          break;
        case 2:
          this.$router.push({path:'collectionGoods',query:{type:1}});
          break;
        case 3:
          this.$router.push({path:'myTracks'});
          break;
        case 4:
          this.$router.push({path:'myOrders',query:{type:1}});
          break;
        case 5:
          this.$router.push({path:'myOrders',query:{type:2}});
          break;
        case 6:
          this.$router.push({path:'myOrders',query:{type:3}});
          break;
        case 7:
          this.$router.push({path:'myOrders',query:{type:4}});
          break;
        case 8:
          this.$router.push({path:'retreat'});
          break;
        case 9:
          this.$router.push({path:'heavyCurrency'});
          break;
        case 10:
          this.$router.push({path:'payRecords'});
          break;
        case 11:
          this.$router.push({path:'chooseAdress'});
          break;
        case 12:
          this.$router.push({path:'MyQrcode'});
          break;
        case 13:
          this.$router.push({path:'myDealer'});
          break;
        case 14:
          this.$router.push({path:'myPost'});
          break;
        case 15:
          this.$router.push({path:'myComment'});
          break;
        case 16:
          Toast('清除成功');
          break;
       
        case 18:
          this.postRequest(`members/receipt/myReceipt`).then(res => {
            if(res.data.code == 0){
              if(res.data.data.state == 1){
                this.$router.push({path:'intelligenceInfo'});
              }else if(res.data.data.state == 0){
                this.$router.push({path:'intelligence'});
              }
            }else if(res.data.code == 1){
              this.$router.push({path:'intelligence'});
            }
            console.log(res)
          })
          break;
        case 19:
          this.showkf= true
          break;
        case 20:
          this.$router.push({path:'myOrders',query:{type:0}});
          break;
      }
    },
    signOut(){
      localStorage.clear();
      this.$router.push({name:'index'});
    },
    ddh(){}
  }
};
</script>


<style scoped lang='less'>

.myIndex {
  .pop {
    border-radius: 7px;
    width: 540px;
    border-radius:10px !important;
    h3{margin-bottom: 10px;}
    /deep/.van-dialog__content {
      height: 251px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      p {
        text-align: center;
        line-height: 50px;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
    /deep/.van-dialog__cancel{
      color: #FF5151;
      font-size: 36px;
    }
    /deep/.van-dialog__confirm:active{
        color: #ffffff;
    }
    /deep/.van-dialog__confirm {
      background: linear-gradient(
        to right,
        rgb(255, 81, 69),
        rgb(229, 47, 35),
        rgb(205, 15, 2)
      );
      font-size: 36px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
  .nobor {
    border: none !important;
  }


  .logout {
    width: 592px;
    margin: 30px auto 0;
    box-sizing: border-box;
    padding-bottom: 90px;
    div {
      width: 100%;
      height: 90px;
      line-height: 90px;
      text-align: center;
      background: #ffffff;
      border-radius: 50px;
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
  }
  .myTop {
    width: 100%;
    height: 522px;
    background: url("../../assets/localImage/wdbg.png");
    background-size: 100% auto;
    .bt {
      padding: 0 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 89px;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    .zl {
      display: flex;
      padding: 45px 49px;
      align-items: center;
      .img {
        width: 120px;
        height: 120px;
        margin-right: 36px;
      }
      p {
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
      .mycode{
        font-size: 24px;
      }
    }
    .number {
      display: flex;
      justify-content: space-around;
      align-items: center;
      div {
        h3 {
          font-size: 36px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          margin-bottom: 4px;
        }
        p {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
  }
  .order {
    width: 710px;
    height: 240px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    margin: 20px auto;
    margin-top: -120px;
    .top {
      height: 80px;
      width: 100%;
      padding: 30px 25px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 80px;
      h2 {
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
      }
      > div {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        display: flex;
        align-items: center;
        > div {
          width: 12px;
          height: 22px;
          margin-left: 18px;
        }
      }
    }
    .body {
      width: 100%;
      height: 160px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      > div {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
      }
      .fk {
        div {
          width: 48px;
          height: 36px;
        }
      }
      .fh {
        div {
          width: 52px;
          height: 38px;
        }
      }
      .sh {
        div {
          width: 40px;
          height: 37px;
        }
      }
      .pj {
        div {
          width: 41px;
          height: 36px;
        }
      }
      .hh {
        div {
          width: 43px;
          height: 40px;
        }
      }
      p {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(68, 68, 68, 1);
        margin-top: 13px;
      }
    }
  }
  .account {
    width: 710px;
    height: 402px;
    background-color: #ffffff;
    margin: auto;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    .top {
      height: 80px;
      width: 100%;
      padding: 30px 25px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 80px;
      h2 {
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
      }
    }
    .body {
      padding: 15px 25px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      > div {
        width: 165px;
        height: 140px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        > div {
          width: 52px;
          height: 52px;
          margin-bottom: 21px;
        }
        p {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(68, 68, 68, 1);
        }
      }
    }
  }
  .operation {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    width: 710px;
    margin: 20px auto;
    padding: 0 30px;
    > div {
      height: 120px;
      display: flex;
      align-items: center;
      .img {
        width: 35px;
        height: auto;
        margin: 0 39px 0 6px;
      }
      .nr {
        border-bottom: 3px solid #f5f5f5;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>


